// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M5 3.79V2M11 3.79V2M4 3.79H12C12.96 3.79 13.76 4.46 13.95 5.36M4 3.79C2.9 3.79 2 4.69 2 5.79V12C2 13.1 2.9 14 4 14H5.25',
  'M4 3.79C2.9 3.79 2 4.69 2 5.8V6.17C2 6.72 2.45 7.17 3 7.17H5.5',
  'M14.4 10.7C14.4 12.74 12.74 14.4 10.7 14.4C8.66 14.4 7 12.74 7 10.7C7 8.66 8.66 7 10.7 7C12.74 7 14.4 8.66 14.4 10.7Z',
  'M10.7 8.65V10.7L12.15 11.7',
];
